import { render, staticRenderFns } from "./AddContactPage.vue?vue&type=template&id=7f3e82cc"
import script from "./AddContactPage.vue?vue&type=script&lang=js"
export * from "./AddContactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports